import { render } from "./ScheduleElection.vue?vue&type=template&id=313f2f04&scoped=true"
import script from "./ScheduleElection.vue?vue&type=script&lang=js"
export * from "./ScheduleElection.vue?vue&type=script&lang=js"

import "./ScheduleElection.vue?vue&type=style&index=0&id=313f2f04&scoped=true&lang=css"

import exportComponent from "/Users/habeebrahman/Documents/htdocs/cdz_projects/wg-frontend-v1/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-313f2f04"]])

export default __exports__